import {componentScripts} from './imports';


// Bootstrap 5
// const bootstrap = require('bootstrap');

// after document loads, loop over all [data-component]s on the page
document.addEventListener('DOMContentLoaded', () =>
{
    // find all elements with component attribute
    const componentElements = document.querySelectorAll('[data-component]');

    // iterate over all component elements
    for (const el of componentElements) {
        let componentName = el.getAttribute('data-component');

        // get the script that matches the component
        let componentScript = componentScripts[componentName];

        // if the script exists, fire the init
        if (typeof componentScript != 'undefined') {
            componentScript.init(el);
        }

        // apply component animations if defined
        // if (el.getAttribute('data-animate') === 'true') {
        //     commonScripts.util.componentAnimation(el);
        // }
    }
});
